module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.notifications), function(item, index) {
    return _c('div', {
      staticClass: "notification-item"
    }, [(index % 2 === 0) ? _c('div', [_c('div', {
      staticClass: "notification-item-first"
    }, [_c('div', {
      staticClass: "notification-item-container"
    }, [_c('div', [_c('p', {
      staticClass: "notification-time-day"
    }, [_vm._v(_vm._s(_vm.displayDate(item.createdTime).day))]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "notification-time-month"
    }, [_vm._v(_vm._s(_vm.displayDate(item.createdTime).month))]), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteNotification(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "notification-item-middle"
    }, [_c('div', {
      staticClass: "notification-item-middle-line",
      style: (_vm.getStyle(item))
    })]), _vm._v(" "), _c('div', {
      staticClass: "notification-item-end"
    }, [_vm._v("\n      " + _vm._s(_vm.getText(item)) + "\n      "), (item.link !== null) ? _c('p', [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.link))])]) : _vm._e(), _vm._v(" "), _c('div')])]) : _vm._e(), _vm._v(" "), (index % 2 === 1) ? _c('div', [_c('div', {
      staticClass: "notification-item-first-right"
    }, [_vm._v("\n      " + _vm._s(_vm.getText(item)) + "\n      "), (item.link !== null) ? _c('p', [_c('a', {
      attrs: {
        "href": item.link
      }
    }, [_vm._v(_vm._s(item.link))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "notification-item-middle-right"
    }, [_c('div', {
      staticClass: "notification-item-middle-line",
      style: (_vm.getStyle(item))
    })]), _vm._v(" "), _c('div', {
      staticClass: "notification-item-end-right"
    }, [_c('div', {
      staticClass: "notification-item-container"
    }, [_c('div', [_c('p', {
      staticClass: "notification-time-day"
    }, [_vm._v(_vm._s(_vm.displayDate(item.createdTime).day))]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "notification-time-month"
    }, [_vm._v(_vm._s(_vm.displayDate(item.createdTime).month))]), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteNotification(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/icons/ic_delete_profile.svg")
      }
    })]) : _vm._e()])])])]) : _vm._e()])
  }), _vm._v(" "), (_vm.showNoNotification) ? _c('div', [_c('div', {
    staticClass: "foo",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/ic_no_notifications.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "no-data-text"
  }, [_vm._v("\n      " + _vm._s(_vm.locale.t('label_no_data_notifications')) + "\n    ")])])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2dd5b734!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/HomeFiskultura.vue
// module id = 747
// module chunks = 0